import PropTypes from 'prop-types';
// @mui
import { Paper, Typography } from '@mui/material';

// ----------------------------------------------------------------------

SearchNotFound.propTypes = {
  query: PropTypes.string,
  sx: PropTypes.object,
};

export default function SearchNotFound({ query, sx, ...other }) {
  return query ? (
    <Paper
      sx={{
        textAlign: 'center',
        ...sx,
      }}
      {...other}
    >
      <Typography variant="h6" paragraph>
        موردی یافت نشد
      </Typography>

      <Typography variant="body2">
        مورد برای عبارت مورد نظر یافت نشد &nbsp;
        <strong>&quot;{query}&quot;</strong>.
        <br /> لطفا عبارت را بررسی و دوباره امتحان کنید
      </Typography>
    </Paper>
  ) : (
    <Typography variant="body2" sx={sx}>
      لطفا عبارت خود را وارد نمایید
    </Typography>
  );
}
